import type {
  DisconnectOAuthResponse,
  GDriveSyncStatusResponse,
  InitiateOAuthResponse,
} from "@nlc/shared-types";
import type {
  DefaultError,
  UseMutationResult,
  UseQueryResult,
} from "@tanstack/react-query";

import { UserRoleEnum } from "@nlc/shared-types";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { useUser } from "@/hooks/useUser.tsx";

import {
  disconnectGoogleOAuth,
  getGoogleOAuthStatus,
  getGoogleOAuthUrl,
} from "../api/googleOAuth";

export function useGoogleDriveStatus(): UseQueryResult<GDriveSyncStatusResponse> {
  const { data } = useUser();

  return useQuery({
    enabled: data?.user?.roleId === UserRoleEnum.Owner,
    queryFn: getGoogleOAuthStatus,
    queryKey: ["google-oauth-status"],
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
}

export function useInitiateGoogleOAuth(): UseMutationResult<
  InitiateOAuthResponse,
  DefaultError,
  void,
  unknown
> {
  return useMutation({
    mutationFn: getGoogleOAuthUrl,
  });
}

export function useDisconnectGoogleOAuth(): UseMutationResult<
  DisconnectOAuthResponse,
  DefaultError,
  void,
  unknown
> {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: disconnectGoogleOAuth,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["google-oauth-status"] });
    },
  });
}
